import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
import '../Workflow.scss';
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { WorkflowTasks } from '../../../services/WorkflowTasks';
import { useWorkflowState } from '../../hooks/useWorkflowStateHook';
import HrbTranslate from '../../../../../components/language/HrbTranslate';
import { TaskStatus } from '../../../services/TaskStatus';
import PaymentApi from '../../../../../services/api/paymentApi';
import { trackEvent, HeapEvents } from '../../../../../services/util/AnalyticsUtil';
import TicketActions from '../../../../../store/ticketRedux';
import Button from '../../../../../components/library/buttons/Button';
import TaskErrorText from '../../../../../components/library/workflow-tasks/TaskErrorText';

const ManualPaymentRteTask = (props) => {
    const { ticket, onHasCompletionErrorChange } = props;
    const [completion, setCompletion] = useState({})
    const [baseStatus, taskCompletions] = useTaskStatus(props.ticket, [WorkflowTasks.PAYMENT_RECEIVED]);
    const [status, setStatus] = useState(baseStatus);
    const [completionData, setCompletionData] = useState({})
    const [showManualPaymentRte, setShowManualPaymentRte] = useState(false);
    const stateTasks = useWorkflowState(props.ticket);
    const [isDisabled, setIsDisabled] = useState(true);
    const [isPendingCompletion, setIsPendingCompletion] = useState(false);
    const [hasCompletionError, setHasCompletionError] = useState(false);
    const dispatch = useDispatch();
    const api = PaymentApi.create();

    useEffect(() => {
        setIsDisabled(status === TaskStatus.COMPLETE || Boolean(props.disabled));
    }, [status])

    useEffect(() => {
        let tcs = taskCompletions || [];
        let completionTask = tcs.find(x => x.status !== TaskStatus.INVALID
            && x.workflowTaskId === WorkflowTasks.PAYMENT_RECEIVED);
        
        var bStatus = baseStatus;
        if (baseStatus !== TaskStatus.COMPLETE && (props.ticket)) { 
            var returnPrepared = props.ticket.taskCompletionStates.find(tcs =>
                tcs.workflowTaskId === WorkflowTasks.PAYMENT_PREPARED && tcs.status !== TaskStatus.INVALID);

            if (returnPrepared && returnPrepared.status === TaskStatus.COMPLETE) {
                bStatus = TaskStatus.IN_PROGRESS;
            }

            if (completionTask && completionTask.status === TaskStatus.COMPLETE) {
                setCompletion(completionTask);
                var cdata = JSON.parse(completionTask.completionData);
                setCompletionData(cdata);
                bStatus = TaskStatus.COMPLETE;
                setShowManualPaymentRte(true);
            }
        }

        setStatus(hasCompletionError ? TaskStatus.ERROR : bStatus);
        onHasCompletionErrorChange(hasCompletionError);
    }, [baseStatus, stateTasks, hasCompletionError, taskCompletions])
    
    const confirmPayment = async () => {
        setIsPendingCompletion(true);
        setHasCompletionError(false);
        var response = await api.completePaymentTask(props.ticket.id);
        if (response && response.ok) {
            dispatch(TicketActions.getTicket(props.ticket.id));
            trackEvent(HeapEvents.COMPLETE_CONFIRM_PAYMENT, props.ticket.id);
        } else {
            setHasCompletionError(true);
        }

        setIsPendingCompletion(false);
    }

    const handleSetShowManualPaymentRte = () => {
        setShowManualPaymentRte(true);
    }
    
    return showManualPaymentRte ? (
        <Fragment>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <p className='p2'><HrbTranslate text='PaymentRteTask.ManualPaymentStep1' /></p>
                </div>
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <p className='p2'><HrbTranslate text='PaymentRteTask.ManualPaymentStep2' /></p>
                </div>
            </div>
             <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>                    
                    {props.ticket &&
                    <div className='step-center-container'>
                        <Button
                            elementId='payment-done-btn'
                            labelKey='PaymentRteTask.PaymentBtn'
                            buttonStyles='primary'
                            onClick={confirmPayment}
                            disabled={(status !== TaskStatus.IN_PROGRESS && status !== TaskStatus.ERROR)}
                            loading={isPendingCompletion}
                            />                                                    
                    </div>
                    }
                    {hasCompletionError &&
                        <TaskErrorText errorKey='PaymentRteTask.ErrorSubmit' />
                    }
                </div>
            </div>
        </Fragment>
    ) : (
            <Fragment>
                <div className='columns prep-section'>
                    <div className='column is-offset-1 is-10'>
                        <p className='p2'><HrbTranslate text='PaymentRteTask.ManualPaymentDescription' /></p>
                    </div>
                </div>
                <div className='columns prep-section'>
                    <div className='column has-text-centered is-offset-1 is-10'>
                        <a onClick={handleSetShowManualPaymentRte}><HrbTranslate text='PaymentRteTask.ManualPaymentLink' disabled={isDisabled} /></a>
                    </div>
                </div>
            </Fragment>
        )
}

ManualPaymentRteTask.whyDidYouRender = false;

ManualPaymentRteTask.propTypes = {
    ticket: PropTypes.object,
    disabled: PropTypes.bool
}

export default ManualPaymentRteTask